var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"success"},on:{"click":function($event){return _vm.getDefaultEntity()}}},[_vm._v(" "+_vm._s(_vm.text)+" "),_c('v-icon',[_vm._v(" "+_vm._s(_vm.icon)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }